import React, {useEffect} from 'react';
import ReportUtils from "../../../../../../utils/report-utils.js";
import ReportHeatmapTable from "../../../../../../components/reports/report-heatmap-table/report-heatmap-table.jsx";

const scale = {
    first: 0,
    firstMid: 0,
    mid: 0,
    midLast: 0,
    last: 0,
};

const DispatchesByWeekDay = ({data}) => {

    useEffect(() => {
        scale.first = parseInt(data[0]?.min);
        scale.last = parseInt(data[0]?.max);
        scale.mid = Math.floor((scale.first + scale.last) / 2);
        scale.firstMid = Math.floor((scale.first + scale.mid) / 2);
        scale.midLast = Math.floor((scale.mid + scale.last) / 2);

        ReportUtils.createExportableTable(null, null, "Despachos por dia da semana", "despatchesByWeekDay");
    }, [data]);

    return (
        <>
            {/*<div id="createDespatchesByWeekDay" className={"break-inside-avoid"}></div>*/}
            <ReportHeatmapTable
              data={data ?? []}
              title="Abordagens por dia da semana com intervalo de 1 hora"
              sheetName="Abordagens por dia da semana"
              tableId="encounter-by-weekday-table"
              rowLabelKey="hour"
              rowPeriodKey="t"
              minKey="min"
              maxKey="max"
              columns={[
                  { key: "segunda", label: "Segunda" },
                  { key: "terca", label: "Terça" },
                  { key: "quarta", label: "Quarta" },
                  { key: "quinta", label: "Quinta" },
                  { key: "sexta", label: "Sexta" },
                  { key: "sabado", label: "Sábado" },
                  { key: "domingo", label: "Domingo" },
              ]}
            />

            <div className="chart-divisor"></div>
        </>
    );
};

export default DispatchesByWeekDay;